var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { dia, util, ui, shapes } from '@joint/plus';
import { VisioArchive, VisioElement, types } from '@joint/format-visio';
var VisioSectionType = types.VisioSectionType, VisioCellName = types.VisioCellName;
var standard = shapes.standard;
export var init = function () { return __awaiter(void 0, void 0, void 0, function () {
    var graph, paper, vsdDocument, page, pageContent, cells;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                graph = new dia.Graph({}, {
                    cellNamespace: __assign(__assign({}, standard), { VisioElement: VisioElement })
                });
                paper = new dia.Paper({
                    el: document.getElementById('paper'),
                    model: graph,
                    width: 1000,
                    height: 600,
                    gridSize: 10,
                    interactive: true,
                    async: true,
                    frozen: true,
                    background: { color: '#F3F7F6' }
                });
                return [4 /*yield*/, VisioArchive.fromURL('./assets/orgchart.vsdx')];
            case 1:
                vsdDocument = (_a.sent()).document;
                page = vsdDocument.getPages()[0];
                return [4 /*yield*/, page.getContent()];
            case 2:
                pageContent = _a.sent();
                cells = pageContent.toGraphCells({
                    importShape: function (vsdShape) {
                        var data = vsdShape.getComputedSection(VisioSectionType.Property);
                        var name = data.getProperty('Name');
                        var title = data.getProperty('Title');
                        var fillForegnd = vsdShape.getCell(VisioCellName.FillForegnd).eval();
                        var _a = vsdShape.getPageBBox(), x = _a.x, y = _a.y, width = _a.width, height = _a.height;
                        var z = vsdShape.getPageZIndex();
                        var element = new standard.EmbeddedImage({
                            position: { x: x, y: y },
                            size: { width: width, height: height },
                            z: z,
                            data: {
                                name: name,
                                title: title,
                                color: fillForegnd
                            },
                            attrs: {
                                root: {
                                    magnetSelector: 'body'
                                },
                                image: {
                                    event: 'element:image:pointerclick',
                                    cursor: 'pointer'
                                },
                                body: {
                                    rx: 5,
                                    ry: 5,
                                    stroke: fillForegnd,
                                    strokeWidth: 3,
                                    fill: fillForegnd,
                                    fillOpacity: 0.3
                                },
                                label: {
                                    fontFamily: 'sans-serif',
                                    fill: '#666666',
                                    text: "".concat(name, "\n").concat(title),
                                    lineHeight: '1.5em',
                                    fontSize: 11,
                                    annotations: [{
                                            start: 0,
                                            end: name.length,
                                            attrs: {
                                                'font-weight': 'bold',
                                                'fill': '#000000'
                                            }
                                        }]
                                }
                            }
                        });
                        return element;
                    },
                    importImage: function (_vsdShape, element, image) {
                        element.attr('image/xlinkHref', image.base64);
                    },
                    importConnect: function (vsdConnect, sourceElement, targetElement) {
                        if (!sourceElement)
                            return null;
                        var _a = vsdConnect.toLinkAttributes(sourceElement, targetElement), vertices = _a.vertices, z = _a.z;
                        var link = new standard.Link({
                            vertices: vertices,
                            z: z,
                            source: { id: sourceElement.id },
                            target: { id: targetElement.id },
                            attrs: {
                                line: {
                                    targetMarker: null,
                                    stroke: sourceElement.prop('data/color'),
                                    strokeWidth: 3
                                }
                            }
                        });
                        return link;
                    }
                });
                graph.resetCells(cells);
                paper.setDimensions(page.width, page.height);
                paper.on('element:image:pointerclick', function (elementView, evt) {
                    evt.stopPropagation();
                    var model = elementView.model;
                    var image = model.attr('image/xlinkHref');
                    var title = util.sanitizeHTML("<p style=\"white-space:pre;\">".concat(model.prop('data/title'), "<br><b>").concat(model.prop('data/name'), "</b></p>"));
                    var lightbox = new ui.Lightbox({ image: image, title: title });
                    lightbox.open();
                });
                paper.unfreeze();
                return [2 /*return*/];
        }
    });
}); };
